<template>
  <div class="wrap">
    <img class="img-bg1" src="@/assets/images/bg.png" alt="" />
    <img class="img-bg2" src="@/assets/images/bg.png" alt="" />
    <img class="img-bg3" src="@/assets/images/bg.png" alt="" />
    <div class="text-content">
      <div class="text-title">{{login.title || ''}}</div>
      <div class="text-desc">{{login.desc || ''}}</div>
    </div>
    <div class="area">
      <div class="top">
        <div class="text">欢迎注册</div>
        <div class="tips">
          已有账号?去<router-link to="login">登录></router-link>
        </div>
      </div>
      <div class="content">
        <el-form :model="form" :rules="formRules" label-width="80px" ref="form">
          <el-form-item prop="userName" label="用户名" >
            <el-input
              v-model="form.userName"
              placeholder="请设置用户名"
              maxlength="50"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="email" label="邮箱">
            <el-input
              v-model="form.email"
              placeholder="请使用企业邮箱注册"
              maxlength="50"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="phone" label="手机号" >
            <el-input
              v-model="form.phone"
              maxlength="20"
              placeholder="请输入手机号"
              class="input-with-select"
            >
              <el-select v-model="form.phoneArea" slot="prepend" placeholder="请选择" style="width:80px" filterable :filter-method="handleSearch">
                <el-option v-for="item in optionsArr" :key="item.id" :label="item.code" :value="item.id">
                  <span style="float: left">{{ item.zh }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.code }}</span>
                </el-option>
              </el-select>
            </el-input>
          </el-form-item>
          <el-form-item prop="company" label="公司名称" >
            <el-input v-model="form.company" placeholder="请输入公司名称(全称)"></el-input>
          </el-form-item>
            <el-form-item prop="realname" label="姓名" >
            <el-input v-model="form.realname" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item prop="password" label="密码">
            <el-input
              v-model="form.password"
              placeholder="请设置登录密码"
              maxlength="50"
              show-password
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="career" label="职位">
            <el-input v-model="form.career" placeholder="请输入职位"></el-input>
          </el-form-item>
          <el-form-item prop="industry" label="行业">
            <el-select v-model="form.industry" placeholder="请选择职位" style="width:100%;">
              <el-option v-for="(item,index) in industryArr" :key="index" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <div class="forget" >
            <span @click="handleTips">用户注册须知></span>
          </div>
        </el-form>
      </div>
      <div class="bottom">
        <el-button type="primary" @click="handleRegister" :loading="isLoading">注册</el-button>
      </div>
    </div>
    <userTips ref="tips"></userTips>
  </div>
</template>

<script>
import phoneArr from '@/utils/phone.js'
import userTips from '@/components/user-tips.vue'
import { login, formRules } from '@/utils/helper.js'
import { industryArr } from '@/config'
import { loginApi } from '@/api/api.js';
export default {
  components: { userTips },
  data () {
    let trim = (rule, value, cb) => {
      let reg = /\s+/g;
      if (reg.exec(value) !== null) {
        cb(new Error(`名称内不能包含空格!`));
      }
      cb();
    };
    let phoneValid = (rule, value, cb) => {
      if (!value) cb(new Error('手机号不能为空!'))
      if (!this.form.phoneArea) cb(new Error('请选择区号!'))
      if (value.length > 11) cb(new Error('手机号最多支持11位！'))
      // let target = phoneArr.find(item => item.id === this.form.phoneArea)
      // let reg = new RegExp(target.preg.substring(1, target.preg.length - 1))
      // if (!reg.test(value)) {
      //   cb(new Error('手机号格式不正确!'))
      // }
      let regx = /^[0-9]*$/
      if (!regx.test(value)) {
        cb(new Error('手机号码必须为数字'))
      }

      cb();
    }
    return {
      isLoading: false,
      login,
      form: {
        userName: '',
        email: '',
        phone: '',
        password: '',
        phoneArea: '37'// 对应中国大陆信息的id
      },
      formRules: {
        userName: [
          { required: true, message: '用户名不能为空!' },
          { validator: formRules.userNameValid }
        ],
        email: [
          { required: true, message: '邮箱不能为空!' },
          { validator: formRules.emailValid, trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '手机号不能为空!', trigger: 'change' },
          { validator: phoneValid, trigger: 'change' }
        ],
        password: [
          { required: true, message: '密码不能为空!' },
          { validator: formRules.passwordValid }
        ],
        company: [
          { required: true, message: '公司名称不能为空!' },
          { max: 20, message: '公司名称长度不能超过20个字符!' },
          { validator: trim }
        ],
        realname: [
          { required: true, message: '姓名不能为空!' },
          { max: 20, message: '姓名长度不能超过20个字符!' },
          { validator: trim }
        ],
        career: [
          { required: true, message: '职位不能为空!' },
          { max: 20, message: '职位长度不能超过20个字符!' }
        ],
        industry: [
          { required: true, message: '行业不能为空!' }
        ]
      },
      optionsArr: [...phoneArr],
      industryArr
    };
  },
  mounted () {
    this.handleTips();
  },
  methods: {
    handleSearch (value) {
      let result = phoneArr.filter((item, index) => {
        if (item.zh.indexOf(value) !== -1 || item.code.indexOf(value) !== -1) {
          return true;
        }
      })
      this.optionsArr = result
    },
    handleTips () {
      this.$refs.tips && this.$refs.tips.showDialog();
    },
    handleRegister () {
      this.$refs.form.validate(valid => {
        if (valid) {
          let target = phoneArr.find(item => item.id === this.form.phoneArea)
          let params = {
            username: this.form.userName,
            email: this.form.email,
            phone: `+${target.code}${this.form.phone}`,
            password: this.form.password,
            company: this.form.company,
            realname: this.form.realname,
            career: this.form.career,
            industry: this.form.industry
          }
          this.isLoading = true;
          loginApi.registerUser(params).then(res => {
            this.isLoading = false;
            if (res.status === 10000) {
              this.$message({
                type: 'success',
                duration: 5000,
                message: '注册成功，激活邮件已发送，请注意查收',
                showClose: true
              })
              this.$router.push('/login')
            } else {
              this.$message.error(res.message)
            }
          })
        }
      })
    }

  }
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/login.scss';
.wrap {
  .area {
    width: 450px;
    padding: 40px 40px 20px 40px;
    .content {
      .input-with-select .el-input-group__prepend {
        background-color: #fff;
      }
    }
    .bottom {
      padding-top: 30px;
      text-align: right;
      ::v-deep .el-button {
        width: 305px;
      }
    }
  }
}
</style>
